import "./ErrorMessage.css"
import {capitalize} from "../../utils/strings";

export const ErrorMessageStyle = {
  DEFAULT: 'default',
  SMALL: 'small',
};

export function ErrorMessage(props) {
  const style = props.style || ErrorMessageStyle.DEFAULT;
  let extraClassName = "";
  switch (style) {
  case ErrorMessageStyle.DEFAULT:
    extraClassName = "text-base";
    break;
  case ErrorMessageStyle.SMALL:
    extraClassName = "text-sm";
    break;
  default:
    break;
  }
  
  return (
    <p className={["py-2 text-red-700 text-base font-semibold", extraClassName].join(' ')}>
      {capitalize(props.children)}
    </p>
  );
}